import React, { useState, useEffect } from 'react'
import styled from 'styled-components'

const CommentsText = styled.span`
  font-family: 'Proxima-Nova';
  font-size: 16px;
  font-weight: 600;
  line-height: 24px; /* 150% */
  letter-spacing: 0.352px;
`
const Count = styled.span`
  font-family: 'Proxima-Nova';
  font-size: 16px;
  font-weight: 400;
  line-height: 24px; /* 150% */
  letter-spacing: 0.352px;
  text-decoration-line: underline;
  cursor: pointer;
`

const CommentCount = ({}) => {
  const [commentCount, setCommentCount] = useState()

  const handleScrollToBottom = () => {
    const commentSection = document.querySelector('.post-comment')
    commentSection.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    })
  }

  useEffect(() => {
    const handleCustomSessionChange = () => {
      const updatedValue = sessionStorage.getItem('commentCount')
      setCommentCount(updatedValue)
    }

    window.addEventListener(
      'session-storage-changed',
      handleCustomSessionChange
    )

    return () => {
      window.removeEventListener(
        'session-storage-changed',
        handleCustomSessionChange
      )
    }
  }, [])

  return (
    <>
      {commentCount >= 0 && (
        <>
          <CommentsText>Comments: </CommentsText>
          <Count onClick={handleScrollToBottom}>
            {commentCount} Comment{commentCount === '1' ? '' : 's'}
          </Count>
        </>
      )}
    </>
  )
}

export default CommentCount
